import { apiPlugin, ApiPluginOptions, TitleMixin } from "@/shared";
import { RegisterGlobalComponents } from "@/shared/components";
import { RegisterTalentBusinessComponents } from "@/shared/components/business-talent";
import { RegisterGlobalFilters } from "@/shared/filters";
import { RegisterGlobalUtils } from "@/shared/utils";
import ElementPlus, { ElCollapseTransition } from "element-plus";
import { createApp } from "vue";
import App from "./App.vue";
/**
 * Layout and global components
 */
import { BottomNavComponent, LeftNavComponent } from "./components";
import "./registerServiceWorker";
import TalentRouter from "./router";
import store from "./store";
import VueGtag from "vue-gtag";

/**
 * Create the main app and attach the needed plugins and modules
 */
const app = createApp(App);
app.config.performance = true;
/**
 * Components
 */
RegisterGlobalComponents(app);
RegisterTalentBusinessComponents(app);

/**
 * Register global components
 */
app
  .use(store)
  .use(TalentRouter)
  .use(apiPlugin, {
    apis: {
      main: process.env.VUE_APP_API_MAIN,
      admin: process.env.VUE_APP_API_ADMIN,
    },
  } as ApiPluginOptions)
  .use(RegisterGlobalFilters)
  .use(RegisterGlobalUtils)
  .mixin(TitleMixin)
  .use(ElementPlus)
  // Enable google analytics
  .use(VueGtag, {
    appName: "Talent",
    config: { id: "G-EHPYD80XK1" },
  })
  /**
   *
   */
  .component("el-collapse-transition", ElCollapseTransition)
  /**
   * Register shared components
   */
  .component("app-left-nav", LeftNavComponent)
  .component("app-bottom-nav", BottomNavComponent)
  /**
   * Mount
   */
  .mount("#app");
